/**
 * Controle de acesso público do site (modo em breve / prévia Dev Hub).
 */

const ALWAYS_ALLOWED_API_PREFIXES = [
  '/api/v1/health',
  '/api/v1/auth',
  '/api/v1/settings/public',
  '/api/v1/contact',
];

/** APIs de leitura do Dev Hub liberadas na prévia pública. */
const DEVHUB_PUBLIC_API_PATTERNS = [
  /^\/api\/v1\/users\/profile\/[^/]+$/i,
  /^\/api\/v1\/users\/badges$/i,
  /^\/api\/v1\/social\/[^/]+\/hub$/i,
  /^\/api\/v1\/social\/[^/]+\/followers$/i,
  /^\/api\/v1\/social\/[^/]+\/following$/i,
  /^\/api\/v1\/social\/hub\/items\/[^/]+\/translate$/i,
];

function normalizePath(pathname = '') {
  const path = String(pathname || '').split('?')[0].replace(/\/+$/, '') || '/';
  return path.toLowerCase();
}

function isDevHubLandingPath(pathname) {
  const path = normalizePath(pathname);
  return path === '/dev-hub' || path === '/devhub';
}

function isPublicProfilePath(pathname) {
  const path = normalizePath(pathname);
  // /perfil/:username (sem sub-rotas administrativas)
  return /^\/perfil\/[^/]+$/.test(path);
}

function isDevHubPublicPath(pathname) {
  return isDevHubLandingPath(pathname) || isPublicProfilePath(pathname);
}

function isAuthPath(pathname) {
  const path = normalizePath(pathname);
  return path === '/entrar' || path === '/login';
}

function isAlwaysAllowedApiPath(apiPath) {
  const path = String(apiPath || '');
  return ALWAYS_ALLOWED_API_PREFIXES.some((prefix) => (
    path === prefix || path.startsWith(`${prefix}/`)
  ));
}

function isDevHubPublicApiPath(apiPath) {
  const path = String(apiPath || '').split('?')[0];
  return DEVHUB_PUBLIC_API_PATTERNS.some((pattern) => pattern.test(path));
}

/**
 * Site restrito pelo modo em breve e/ou pela prévia pública do Dev Hub.
 * Com prévia ativa: /dev-hub e /perfil/:username ficam abertos para todos.
 */
function shouldShowComingSoon({
  maintenanceMode,
  devHubPublicAccess,
  pathname,
  isAdmin,
}) {
  if (isAdmin || isAuthPath(pathname)) return false;

  const siteRestricted = Boolean(maintenanceMode) || Boolean(devHubPublicAccess);
  if (!siteRestricted) return false;

  if (devHubPublicAccess && isDevHubPublicPath(pathname)) return false;

  return true;
}

module.exports = {
  ALWAYS_ALLOWED_API_PREFIXES,
  ALWAYS_ALLOWED_PREFIXES: ALWAYS_ALLOWED_API_PREFIXES,
  isDevHubLandingPath,
  isPublicProfilePath,
  isDevHubPublicPath,
  isAuthPath,
  isAlwaysAllowedApiPath,
  isDevHubPublicApiPath,
  shouldShowComingSoon,
  normalizePath,
};
